<div class="box-menu-settings" [class.active]="isDeformityDone">

	<div class="row-box">
		<h4>{{ labels().TOOLS_MENU_COMPONENT_CORRECTION }}</h4>
		@if (isCorrectionDone) {<div class="check-success ms-auto"></div>}
	</div>

	<div class="divider-box"></div>

	@if (stateType !== stateTypeEnum.EOC) {
	<div data-testid="SUBSYS4_CORRMENU_ACTIVATE_BTN" class="row-box"
		[class]="{'clickable': isDeformityDone, 'not-allowed': !isDeformityDone }" (click)="enableCorrection()"
		(keypress)="enableCorrection()">
		<i class="material-icons">more_horiz</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_ACTIVATE }}</span>
	</div>
	} @else {

	<div data-testid="SUBSYS4_CORRMENU_OSTEOTOMY_BTN" class="row-box"
		[class]="{'clickable': !isEocCut, 'disabled': !!isEocCut }" (click)="openOsteotomyWorkflow()"
		(keypress)="openOsteotomyWorkflow()">
		<div class="fake-material-icon osteotomy"></div>
		<span>{{ labels().TOOLS_MENU_COMPONENT_OSTEOTOMY_SITE }}</span>
	</div>
	@if (cutForm) {
	<form [formGroup]="cutForm">
		<div class="row-box">
			<div class="form-group pb-0">
				<div data-testid="SUBSYS4_CORRMENU_OPENING_BTN" class="custom-control custom-radio custom-control-inline pt-0"
					(click)="setOpening()" (keypress)="setOpening()">
					<input type="radio" id="opening" name="cutType" class="custom-control-input" [value]="cutType.opening"
						formControlName="cutType" />
					<label class="custom-control-label" for="opening">{{ labels().TOOLS_MENU_COMPONENT_OPENING }}</label>
				</div>
				<div data-testid="SUBSYS4_CORRMENU_CLOSING_BTN" class="custom-control custom-radio custom-control-inline pt-0"
					(click)="setClosing()" (keypress)="setClosing()">
					<input type="radio" id="closing" name="cutType" class="custom-control-input" [value]="cutType.closing"
						formControlName="cutType" />
					<label class="custom-control-label" for="closing">{{ labels().TOOLS_MENU_COMPONENT_CLOSING }}</label>
				</div>
			</div>
		</div>
		<div class="row-box flex-wrap pe-0">
			<i class="material-icons">crop_rotate</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_CUT }}</span>
			<div class="form-group switch-custom-container align-items-center pb-0 ms-4 mb-0"
				[class]="{'disabled': !osteotomyCut }" style="width: fit-content;">
				<label data-testid="SUBSYS4_CORRMENU_CUT_BTN" class="switch" aria-label="enable cut mode" (click)="setCut()"
					(keypress)="setCut()">
					<input type="checkbox" formControlName="cut" />
					<span></span>
				</label>
				<p class="mb-0">{{ labels().TOOLS_MENU_COMPONENT_ON_OFF }}</p>
				<i data-testid="SUBSYS4_CORRMENU_RESET_CUT_BTN" class="material-icons img-action p-2 ms-3"
					[class]="{'clickable': isEocCut, 'disabled': !isEocCut }" (click)="resetCut()" (keypress)="resetCut()">
					sync
				</i>
			</div>
		</div>
	</form>
	}

	}

</div>